module.exports = __webpack_public_path__ + "img/92.afd1ea59.jpg";